import type { FC } from "react";

import { ShoppingBagIcon } from "@jti/brand-icons/shopping-bag";

import { HeaderNavListItem } from "../HeaderNavListItem";

export type HeaderMiniCartProps = {
  label: string;
  count?: number;
  onClick: () => void;
};

export const HeaderMiniCart: FC<HeaderMiniCartProps> = ({ label, count, onClick }) => {
  const displayLabel = typeof count === "number" && count > 0 ? `${label} (${count})` : label;

  return <HeaderNavListItem label={displayLabel} startIcon={ShoppingBagIcon} onClick={onClick} isCondensed={true} />;
};
